import React from 'react';
import Label, { useLabels } from "components/general/Label"
import {
  RESULT_STATUS,
  SCHEDULE_STATUS,
  getScheduleStatusAsInteger,
  getResultStatusAsInteger,
  scheduleIsRunningStatus,
  isLiveStatus
} from "helpers/status";

export const Status = ({ typeToPrint, scheduleStatus, resultStatus, onlyTextH1 = false, onlyCodeForEvent = false }) => {
  const fLabel = useLabels();
  if (typeToPrint !== 'schedule') {
    typeToPrint = 'result'
  }

  scheduleStatus = isNaN(scheduleStatus) ? getScheduleStatusAsInteger(scheduleStatus) : scheduleStatus;
  resultStatus = isNaN(resultStatus) ? getResultStatusAsInteger(resultStatus) : resultStatus;

  if (scheduleStatus === SCHEDULE_STATUS.GETTING_READY || scheduleStatus === SCHEDULE_STATUS.SCHEDULED_BREAK) {
    scheduleStatus = SCHEDULE_STATUS.RUNNING
  }

  if (typeToPrint === 'result'
    && (resultStatus === RESULT_STATUS.OFFICIAL || resultStatus === RESULT_STATUS.PROTESTED || resultStatus === RESULT_STATUS.PROVISIONAL || scheduleStatus === 0)) {
    typeToPrint = 'result'
  } else {
    typeToPrint = 'schedule'
  }

  let printStatus;
  let classStatus;

  if (scheduleStatus > SCHEDULE_STATUS.SCHEDULED) {
    if (typeToPrint === 'schedule') {
      printStatus = 'status_' + scheduleStatus
    } else {
      printStatus = 'resultStatus_' + resultStatus
    }
  } else if (scheduleStatus === 0) {  // to avoid void status in subunits not scheduled
    printStatus = 'resultStatus_' + resultStatus
  }

  if (onlyCodeForEvent) {
    return printStatus
  }

  if (onlyTextH1) {
    // Esta parte es para los H1 para comprobar si tiene Status
    if (scheduleStatus === SCHEDULE_STATUS.SCHEDULED && resultStatus === RESULT_STATUS.START_LIST) {
      return fLabel({ data: 'resultStatus_' + RESULT_STATUS.START_LIST })
    } else {
      return scheduleStatus === 0 ? null : fLabel({ data: printStatus })
    }
  } //scheduleStatus == 2 devolvemos un " " para que la cabecera pinte el enfrentamiento 

  if (scheduleIsRunningStatus(scheduleStatus)) {
    classStatus = 'currentIndicator liveStatus'
  }
  if (resultStatus === -1 && scheduleStatus === 0) {
    return ('')
  } else {
    return (
      <div className={`d-inline fw-bold text-nowrap ${printStatus ? classStatus : ''}`}>
        <Label data={printStatus} noHtml={true} />
      </div>
    )
  }

};

const StatusMemo = React.memo(Status);

export default StatusMemo